import type { ReactNode } from 'react'
import { AlertTriangle, CheckCircle2, Info, Star, XCircle } from 'lucide-react'
import { cn } from '@/shared/lib/utils'
import { toneSoftClass, type V2Tone } from './tone'

const toneIcon: Record<V2Tone, typeof Info> = {
  neutral: Info,
  brand: Info,
  accent: Star,
  ok: CheckCircle2,
  warn: AlertTriangle,
  err: XCircle,
}

/**
 * Encart contextuel (info/accent/succès/alerte/erreur) - token V2 `.callout`.
 * `role="alert"` pour warn/err (annonce SR), sinon contenu statique.
 */
export function Callout({
  tone = 'brand',
  title,
  children,
  className,
}: {
  tone?: V2Tone
  title?: ReactNode
  children?: ReactNode
  className?: string
}) {
  const Icon = toneIcon[tone]
  const assertive = tone === 'warn' || tone === 'err'

  return (
    <div
      role={assertive ? 'alert' : undefined}
      className={cn('flex gap-3 rounded-lg border p-4', toneSoftClass[tone], className)}
    >
      <Icon className="mt-0.5 size-5 shrink-0" aria-hidden />
      <div className="min-w-0 space-y-1">
        {title ? <p className="text-sm font-semibold">{title}</p> : null}
        {children ? <div className="text-sm leading-relaxed">{children}</div> : null}
      </div>
    </div>
  )
}
